import { AppointmentByIdQuery, AppointmentReviewMutation, GetToken } from '@water-web/api';

export const AppointmentServiceConstructor = (config: { baseUrl: string; getToken: GetToken }) => ({
  getById: new AppointmentByIdQuery(config.baseUrl),
  review: new AppointmentReviewMutation(config),
});
